module.exports = __webpack_public_path__ + "static/media/overpass-thin.69bb205a.ttf";